// extracted by mini-css-extract-plugin
export default {"Photo":"Photo_-RN-l","buttons":"buttons_6rAaj","PhotoPending":"PhotoPending_LeNPV"};